import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "hooks";
import { menuDistrict } from "../sidebarMenuConstants";
import { MenuSelectionProvider } from "./MenuSelectionContext";

// SidebarContext shape
const SidebarContext = createContext({
  isMainSidebar: false,
  listItems: [],
  showSidebar: false,
  setSidebar: () => undefined,
});

export const SidebarProvider = ({ children }) => {
  // states
  const [showDistrictSidebar, setDistrictSidebar] = useLocalStorage(
    "districtSidebar",
    true
  );
  // memoized context value
  const value = useMemo(() => {
    return {
      isMainSidebar: false,
      listItems: menuDistrict,
      showSidebar: showDistrictSidebar,
      setSidebar: setDistrictSidebar,
    };
  }, [showDistrictSidebar, setDistrictSidebar]);

  return (
    <SidebarContext.Provider value={value}>
      <MenuSelectionProvider>{children}</MenuSelectionProvider>
    </SidebarContext.Provider>
  );
};

// consumer hook
export const useSidebarContext = () => useContext(SidebarContext);
